/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RefundAccountResponseDto } from '../../models/refund-account-response-dto';

export interface UserControllerGetRefundAccount$Params {
}

export function userControllerGetRefundAccount(http: HttpClient, rootUrl: string, params?: UserControllerGetRefundAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<RefundAccountResponseDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerGetRefundAccount.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RefundAccountResponseDto>;
    })
  );
}

userControllerGetRefundAccount.PATH = '/api/user/me/refund-account';
